import { render } from "./ElectronicNoticeViewPage.vue?vue&type=template&id=fc963ff8"
import script from "./ElectronicNoticeViewPage.vue?vue&type=script&lang=js"
export * from "./ElectronicNoticeViewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__